import type { WizardState } from './types';

/**
 * O corpo do POST /cooperado/cteos a partir do estado do assistente. `vTPrest` é o
 * centavos→reais do passo de valor; a alíquota final é recalculada no servidor (o
 * cliente só autora `vTPrest`, nunca o imposto).
 */
export function montarCorpoCteos(estado: WizardState, idVeiculo: number, idempotencyKey: string | null) {
  const vTPrest = estado.valorCentavos / 100;
  const doc = estado.tomaCpfCnpj.replace(/\D/g, '');
  return {
    tomaNome: estado.tomaNome,
    tomaCPF: doc.length === 11 ? estado.tomaCpfCnpj : undefined,
    tomaCNPJ: doc.length === 14 ? estado.tomaCpfCnpj : undefined,
    viagens: [{
      dataIda: estado.dataIda, horarioIda: estado.horarioIda,
      dataVolta: estado.somenteIda ? estado.dataIda : estado.dataVolta,
      horarioVolta: estado.somenteIda ? estado.horarioIda : estado.horarioVolta,
      municipioOrigem: estado.cMunIni, municipioDestino: estado.cMunFim,
    }],
    veiculos: [{ idVeiculo, tipoPrincipal: true }],
    componentes: [{ nomeComponente: 'FRETE', valorComponente: vTPrest }],
    vTPrest,
    descServico: 'TRANSPORTE DE PESSOAS',
    idempotencyKey,
  };
}

/**
 * O corpo do POST /cooperado/atf, referenciando o CT-e já emitido. Sem a chave de
 * idempotência: ela vai à parte no envio, porque este corpo é também o que se grava
 * para concluir a emissão depois de a página fechar.
 */
export function montarCorpoAtf(estado: WizardState, numeroDocFiscal: string, serieDocFiscal: string) {
  return {
    idVeiculoSgtf: estado.idVeiculoSgtf,
    placa: estado.placa,
    idCondutorSgtf: estado.idCondutorSgtf,
    condutorNomeCpf: estado.condutorNomeCpf,
    municipioOrigem: estado.municipioOrigemIndice,
    municipioDestino: estado.municipioDestinoIndice,
    dataIda: estado.dataIda,
    dataVolta: estado.somenteIda ? estado.dataIda : estado.dataVolta,
    horarioIda: estado.horarioIda,
    horarioVolta: estado.somenteIda ? estado.horarioIda : estado.horarioVolta,
    kmIda: estado.kmIda,
    kmVolta: estado.somenteIda ? 0 : estado.kmVolta,
    numeroDocFiscal,
    serieDocFiscal,
    itinerario: estado.itinerario,
    passageiros: estado.passageiros,
    somenteIda: estado.somenteIda,
  };
}

export type CorpoAtf = ReturnType<typeof montarCorpoAtf>;
